import React from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export const linkVariable = (link: string, text: string) => renderToStaticMarkup(<a href={link}>{text}</a>);
